"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.STICKY_CLASS = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _tooltip = _interopRequireDefault(require("../../tooltip"));

var _constants = require("../constants");

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var STICKY_CLASS = 'xsui-table-head-cell--sticky-col';
exports.STICKY_CLASS = STICKY_CLASS;

var HeadCell = /*#__PURE__*/function (_PureComponent) {
  _inherits(HeadCell, _PureComponent);

  var _super = _createSuper(HeadCell);

  function HeadCell() {
    var _this;

    _classCallCheck(this, HeadCell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "textRef", /*#__PURE__*/(0, _react.createRef)());

    _defineProperty(_assertThisInitialized(_this), "cellRef", /*#__PURE__*/(0, _react.createRef)());

    _defineProperty(_assertThisInitialized(_this), "state", {
      isCellHigh: false,
      cellOffsetLeft: null
    });

    _defineProperty(_assertThisInitialized(_this), "headTextCheck", function () {
      var iteration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (!_this.textRef.current || iteration > 1) {
        return;
      }

      var clientHeight = _this.textRef.current.clientHeight;
      var isCellHigh = clientHeight > _constants.MAX_CELL_HEIGHT; // Если после обновления ноды, текст слишком большой, тогда вернем соокращение

      _this.setState({
        isCellHigh: isCellHigh
      }, function () {
        return !isCellHigh && _this.headTextCheck(iteration + 1);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.headTextCheck();
    });

    _defineProperty(_assertThisInitialized(_this), "setCellOffset", function () {
      var cell = _this.cellRef.current;

      if (!cell) {
        return;
      }

      if (cell && _this.props.column.sticky) {
        _this.setState({
          cellOffsetLeft: cell.offsetLeft
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isShowTooltip", function () {
      return !!_this.props.column.description || _this.state.isCellHigh;
    });

    _defineProperty(_assertThisInitialized(_this), "renderCellContent", function () {
      if (_this.isShowTooltip()) {
        return _this.renderTooltip();
      }

      return _this.renderName();
    });

    _defineProperty(_assertThisInitialized(_this), "renderName", function () {
      var isShowTooltip = _this.isShowTooltip();

      return /*#__PURE__*/_react["default"].createElement("p", {
        ref: _this.textRef,
        className: cx('xsui-table-head-cell__text', isShowTooltip && 'xsui-table-head-cell__text--hover', _this.state.isCellHigh && 'xsui-table-head-cell__text--shorted')
      }, _this.props.column.name);
    });

    _defineProperty(_assertThisInitialized(_this), "renderTooltip", function () {
      var _this$props$column = _this.props.column,
          name = _this$props$column.name,
          description = _this$props$column.description;
      var isCellHigh = _this.state.isCellHigh;
      return /*#__PURE__*/_jsx(_tooltip["default"], {
        className: cx('xsui-table-head-cell__tooltip', isCellHigh && 'xsui-table-head-cell__tooltip--fluid'),
        label: /*#__PURE__*/_jsx("div", {}, void 0, !!description && /*#__PURE__*/_jsx("p", {}, void 0, description), isCellHigh && /*#__PURE__*/_jsx("p", {}, void 0, name))
      }, void 0, _this.renderName());
    });

    _defineProperty(_assertThisInitialized(_this), "renderCell", function () {
      var _this$props = _this.props,
          column = _this$props.column,
          compact = _this$props.compact,
          stickyRow = _this$props.stickyRow;
      var isStickyCell = column.sticky || stickyRow;
      return /*#__PURE__*/_jsx("div", {
        className: cx('xsui-table-head-cell__wrapper', isStickyCell && 'xsui-table-head-cell__wrapper--fit', compact && 'xsui-table-head-cell__wrapper--compact', _this.state.isCellHigh && 'xsui-table-head-cell__wrapper--shorted')
      }, void 0, /*#__PURE__*/_jsx(_react.Fragment, {}, void 0, /*#__PURE__*/_jsx("div", {
        className: cx('xsui-table-head-cell__border-bottom')
      }), !column.sticky && /*#__PURE__*/_jsx("div", {
        className: cx('xsui-table-head-cell__border', compact && 'xsui-table-head-cell__border--compact')
      }), _this.renderCellContent(), column.sticky && /*#__PURE__*/_jsx("div", {
        className: cx('xsui-table-head-cell__border', 'xsui-table-head-cell__border--sticky-column')
      })));
    });

    return _this;
  }

  _createClass(HeadCell, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.headTextCheck();
      window.addEventListener('resize', this.handleResize);
      this.setCellOffset();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.column.name !== prevProps.column.name) {
        this.headTextCheck();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          column = _this$props2.column,
          compact = _this$props2.compact,
          stickyRow = _this$props2.stickyRow;
      var cellOffsetLeft = this.state.cellOffsetLeft;
      var renderHeadCell = column.renderHeadCell,
          width = column.width,
          minWidth = column.minWidth,
          maxWidth = column.maxWidth,
          _column$show = column.show,
          show = _column$show === void 0 ? true : _column$show,
          sticky = column.sticky;

      if (!show) {
        return null;
      }

      var classes = cx('xsui-table-head-cell', stickyRow && 'xsui-table-head-cell--sticky-row', sticky && STICKY_CLASS);
      var styles = {
        width: width,
        minWidth: minWidth || width,
        maxWidth: maxWidth || width,
        left: sticky && cellOffsetLeft
      };

      if (renderHeadCell) {
        return renderHeadCell({
          column: column,
          compact: compact,
          sticky: sticky,
          className: classes,
          style: styles
        });
      }

      return /*#__PURE__*/_react["default"].createElement("th", {
        ref: this.cellRef,
        style: styles,
        className: classes
      }, this.renderCell());
    }
  }]);

  return HeadCell;
}(_react.PureComponent);

var _default = HeadCell;
exports["default"] = _default;